import styled from "styled-components";
import Switch from "rc-switch";

export const ToggleWrapper = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  font-size: var(--fs-base);
  color: var(--primary-blue);
  white-space: nowrap;
`;

export const Toggle = styled(Switch)`
  background-color: ${({ isCheck }) =>
    isCheck ? "var(--primary-blue)" : "var(--primary-dark-100)"};
  border-color: ${({ isCheck }) => (isCheck ? "var(--primary-blue)" : "var(--primary-dark-100)")};
`;
